const Git = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="skill-icon"
    >
      <path
        d="M124.742 58.378L69.6252 3.26405C66.4532 0.090045 61.3052 0.090045 58.1282 3.26405L46.6852 14.71L61.2032 29.228C64.5782 28.089 68.4462 28.853 71.1352 31.542C72.4167 32.8247 73.3113 34.4421 73.7168 36.2092C74.1223 37.9764 74.0223 39.822 73.4282 41.535L87.4202 55.529C90.8052 54.362 94.7122 55.116 97.4142 57.824C101.194 61.601 101.194 67.724 97.4142 71.503C96.5159 72.4018 95.4493 73.1147 94.2755 73.6011C93.1016 74.0875 91.8434 74.3379 90.5727 74.3379C89.302 74.3379 88.0438 74.0875 86.8699 73.6011C85.696 73.1147 84.6295 72.4018 83.7312 71.503C82.3816 70.1526 81.4616 68.4331 81.087 66.561C80.7125 64.6889 80.9 62.7478 81.6262 60.982L68.5782 47.933L68.5762 82.274C69.5229 82.7402 70.3872 83.3577 71.1352 84.102C74.9142 87.879 74.9142 94 71.1352 97.785C67.3562 101.562 61.2312 101.562 57.4562 97.785C53.6782 94.0011 53.3682 87.88 57.1452 84.102C58.0792 83.169 59.0002 82.464 60.0002 81.992V47.333C59.0002 46.861 58.0802 46.161 57.1442 45.222C54.2832 42.362 53.7482 38.162 55.2162 34.646L40.9832 20.333L3.22918 58.123C0.0541837 61.3 0.0741837 66.448 3.24918 69.623L58.3752 124.737C61.5482 127.911 66.7002 127.911 69.8782 124.737L124.738 69.879C127.913 66.703 127.916 61.552 124.742 58.378Z"
        fill="#00E96C"
      />
    </svg>
  );
};

export default Git;
